import { defineStore } from 'pinia'
import router from '@/router/router'
import userManagementService from '@/service/UserManagementService'
import socketService from '@/service/SocketService'
import notificationService from '@/service/NotificationService'
import { useStorage } from '@vueuse/core'
import { rolesEnum } from '@/helpers/Constants'
import { useGlobalStore } from '@/stores/global'

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        user: useStorage('userInfo', {}),
        returnUrl: null,
        unreadChatsMessages: 0,
        unreadOperationsMessages: 0,
    }),
    actions: {
        async login() {
            const passwordCopy = this.user.password
            this.user.password = ''
            const authenticationResponse = await userManagementService.authenticate(this.user.username, passwordCopy)
            this.user.token = authenticationResponse.result.token
            const userInfoResponse = await userManagementService.getUserInfo()
            this.user.id = userInfoResponse.result.id
            this.user.roles = userInfoResponse.result.authorities.map(a => a.name)
            this.user.imageUrl = userInfoResponse.result.imageUrl
            const homePage = this.user.roles.includes(rolesEnum.ROLE_ADMIN) ? '/controlPanel' : '/home'
            router.push(this.returnUrl || homePage)
            this.unreadChatsMessages = 0
            this.unreadOperationsMessages = 0
            notificationService.loadNotificationsCount()
            socketService.connect()
        },
        async pullUserData() {
            const userInfoResponse = await userManagementService.getUserInfo()
            this.user.imageUrl = userInfoResponse.result.imageUrl
        },
        logout() {
            try {
                const globalStore = useGlobalStore()
                this.user = {}
                socketService.disconnect()
                globalStore.closeDialogs()
            } catch (error) {
                // nothing special, best effort
            }
            finally {
                // just in case the above does not close the dialog
                document.querySelectorAll("div.p-dialog button.p-dialog-header-close").forEach(d => d.click())
                router.push('/login')
            }
        },
        userIsLogged() {
            return this.user.token !== null && this.user.token !== undefined
        },
        getUserProfilePhoto() {
            if (this.user.imageUrl !== null && this.user.imageUrl !== undefined) {
                return this.user.imageUrl
            }
            return require('@/assets/avatar.png')
        },
        isCurrentUser(someUser) {
            return someUser === this.user.username
        },
        amIAdmin() {
            return this.user.roles !== null && this.user.roles !== undefined && this.user.roles.includes(rolesEnum.ROLE_ADMIN)
        }
    }
})